import React,{useState}from 'react';

const RecipesItems=props=> {
    const [show,setShow]=useState(false); 
    const [showDiet,setShowDiet]=useState(false);
    const [showCauion,setShowCauion]=useState(false);
    const {label,image,ingredientLines,url,cautions,dietLabels}=props;
    return (
        <div className="col-md-3 mt-5">
                        <div className="card py-2 text-center">
                            <img  src={image} alt={label} onClick={()=>setShow(!show)} className="img-fluid w-100"/>
                            
                            <div className="card-body">
                                <h5>{label}</h5>

                            </div>
                            <button className="btn btn-dark" onClick={()=>setShow(!show)}>Ingredients</button>
                            {show &&(
                            <ul className="list-group list-group-flush">
                                {
                                    ingredientLines.map(ingredient=>(<li className="list-group-item">{ingredient}</li>))
                                }
                                </ul>)
                            }
                            <button className="btn btn-dark" onClick={()=>setShowDiet(!showDiet)}>DietLabels</button>
                            {showDiet &&(
                            <ul className="list-group list-group-flush">
                                {
                                    dietLabels.map(ingredient=>(<li className="list-group-item">{ dietLabels}</li>))
                                }
                                </ul>)
                            }
                            <button className="btn btn-dark" onClick={()=>setShowCauion(!showCauion)}>Cautions</button>
                            {showCauion &&(
                            <ul className="list-group list-group-flush">
                                {
                                    cautions.map(cautions=>(<li className="list-group-item">{cautions}</li>))
                                }
                                </ul>)
                            }
 
                        
                            <a href={url} className="card-link bg-dark text-light text-decoration-none">Video Link</a>
                        </div>
                    </div>
    );
}

export default RecipesItems;